import React from 'react'
import { ClipboardList, Plus } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const ApprovalTemplates: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Approval Templates</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Configure approval workflow templates</p>
        </div>
        <Button><Plus className="w-4 h-4 mr-2" />Create Template</Button>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ClipboardList className="w-5 h-5" />Workflow Templates
          </CardTitle>
          <CardDescription>Pre-configured approval process templates</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <ClipboardList className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Approval Templates</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Design and manage approval workflows</p>
            <Button variant="outline">Create Workflow</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
